<template>
  <van-popup v-model:show="showGuide" position="top" :z-index="2006" :lock-scroll="false"
    :close-on-click-overlay="false" round>
    <div class="guideToInstall">
      <van-space align="start">
        <Image v-if="logo" :src="logo" alt="" class="size-16 shrink-0" />
        <span class="text-[13px] font-[400] w-[70%] text-white">Gostaríamos de mostrar notificações
          para as últimas notícias e
          atualizações.</span>
      </van-space>
      <van-button color="var(--theme-primary)" class="w-full mt-3" @click="handleGetNotificationPermission">
        <span class="text-[#151A1F] font-[500] text-[16px]">Receber notificações</span>
      </van-button>
      <span class="closeIcon2 absolute top-12 right-6" @click="showGuide = false" />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
// IOS添加到桌面中获取系统通知权限时，先弹窗提醒，再申请权限
import { useHomeBannersAndTexts } from "@/store";
import { getImageUrl } from "@/utils";
import { isInAndroidApp, isInIframe, isInPWA, isFromIOSScreen } from '@/env';
import initWP from '@/utils/webpush'
const allConfig = useHomeBannersAndTexts();
const logo = computed(() => getImageUrl(allConfig.pwaConfig.pwaIcon))
const showGuide = ref(false);


const handleGetNotificationPermission = () => {
  initWP()
  if (window.Notification) {
    window.Notification.requestPermission().then(permission => {
      console.log('Notification permission:', permission)
      showGuide.value = false
    })
  }
}

onMounted(() => {
  // 检查是否已经有通知权限 "default": 用户还未做出选择，"granted": 用户已经授权，"denied": 用户已经拒绝
  const notificationPermission = window.Notification?.permission
  // console.log('%c [ notificationPermission ]-44', 'font-size:13px; background:#9a5567; color:#de99ab;', notificationPermission, isFromIOSScreen)
  if (isFromIOSScreen && location.pathname !== '/template/' && notificationPermission === 'default') {
    showGuide.value = true
  }
  // console.log('%c [ isInAndroidApp ]-49', 'font-size:13px; background:pink; color:#bf2c9f;', isInAndroidApp)
  // console.log('%c [ isInIframe ]-50', 'font-size:13px; background:pink; color:#bff;', isInIframe)
  // console.log('%c [ isInPWA ]-51', 'font-size:13px; background:pink; color:#c9f;', isInPWA)
  // console.log('%c [ location.pathname ]-52', 'font-size:13px; background:pink; color:#b9c;', location.pathname)
  // 安卓和PWA中获取通知权限时，直接申请权限
  if (!isFromIOSScreen && !(isInAndroidApp || isInIframe || !isInPWA && location.pathname == '/template/')) {

    // console.log('%c [ initWP ]-49', 'font-size:13px; background:#2d8bc7; color:#71cfff;',)
    initWP()
    if (window.Notification) {
    window.Notification.requestPermission()
  }
  }
})
// onActivated(() => {

//   console.log('%c [ onActivated ]-50', 'font-size:13px; background:#e8331c; color:#ff7760;',)
// })

</script>

<style lang="scss" scoped>
.guideToInstall {
  @apply p-3 !bg-[#1B1F24] border-[var(--theme-primary)] border-solid border-[2px] mx-4 my-4 mt-10 rounded-[8px];
}
</style>
